var map = {
	"./death.png": 935,
	"./judgement.png": 936,
	"./justice.png": 937,
	"./strength.png": 938,
	"./temperance.png": 939,
	"./the_chariot.png": 940,
	"./the_devil.png": 941,
	"./the_emperor.png": 942,
	"./the_empress.png": 943,
	"./the_fool.png": 944,
	"./the_hanged_man.png": 945,
	"./the_hermit.png": 946,
	"./the_hierophant.png": 947,
	"./the_high_priestess.png": 948,
	"./the_lovers.png": 949,
	"./the_magician.png": 950,
	"./the_moon.png": 951,
	"./the_star.png": 952,
	"./the_sun.png": 953,
	"./the_tower.png": 954,
	"./the_world.png": 955,
	"./wheel_of_fortune.png": 956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;